import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { HashRouter, Switch } from 'react-router-dom'

import Loading from './components/common/Loading'

import { Token, NewAccount, UnlockAccount, Balances, TransactionHistory } from './asyncRoute'

import BncClientProvider from './containers/context/BNCClientProvider'
import WalletConnectProvider from './containers/context/WalletConnectProvider'
import { GoogleAnalyticsProvider } from './ga'
import CommonDataProvider from './network/CommonDataProvider'
import { RouteWithRedirect, addLocalePrefix } from './i18n/util'

class RootRoute extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
    isHardware: PropTypes.bool,
  }

  static defaultProps = {
    isLoading: false,
    isHardware: false,
  }

  render() {
    const { isLoading, isHardware } = this.props
    return (
      <BncClientProvider>
        <WalletConnectProvider>
          <HashRouter>
            <div>
              <Switch>
                <RouteWithRedirect
                  exact={true}
                  path={addLocalePrefix('/create')}
                  component={NewAccount}
                />
                <RouteWithRedirect
                  exact={true}
                  path={addLocalePrefix('/unlock')}
                  component={UnlockAccount}
                />
                <RouteWithRedirect
                  exact={true}
                  path={addLocalePrefix('/tokens')}
                  component={Token}
                />
                <RouteWithRedirect
                  exact={true}
                  path={addLocalePrefix('/balances')}
                  component={Balances}
                />
                <RouteWithRedirect
                  exact={true}
                  path={addLocalePrefix('/transactionHistory')}
                  component={TransactionHistory}
                />
              </Switch>

              {/* Loading spinner */}
              {/* NOTE: Temporarily disabled for hardware wallets */}
              {isLoading && !isHardware && <Loading />}
              <CommonDataProvider />
              <GoogleAnalyticsProvider />
            </div>
          </HashRouter>
        </WalletConnectProvider>
      </BncClientProvider>
    )
  }
}

const mapStateToProps = ({
  globalData: { isLoading },
  account: {
    flags: { isHardware },
  },
}) => ({
  isLoading,
  isHardware,
})

export default connect(mapStateToProps)(RootRoute)
